import * as svg from "../../../assets/support-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const SupportIcon = iconBuilder(svg, "SupportIcon", "0 0 20 21");
